export enum PaymentStatus {
    Pending = 'pending',
    Payed = 'payed',
    Failed = 'failed'
}
